import { createPortal } from 'react-dom';
import {

  ModalContent,
  ModalOverlay,
  CloseBtn,
  ScrollBox,
} from './Modal.styled';
import ImageAnimation3 from 'components/layout/loader/ImageAnimation3';
import { useRef } from 'react';

const modalRoot = document.querySelector('#root-module');

const Modal = ({ children, onClose, pad, heightT = false, loading = 1,nqe = false }) => {
  // console.log('loading :>> ', loading);
   const shouldClose = useRef(false);

  const handleContentClick = event => {
    event.stopPropagation();
  };

  const handleMouseDown = (e) => {
    shouldClose.current = e.target === e.currentTarget;
  };
 const handleMouseUp = (e) => {
    if (
      shouldClose.current &&
      e.target === e.currentTarget
    ) {
      onClose();
    }

    shouldClose.current = false;
  };
console.log('nqe :>> ', nqe);
  return createPortal(
  <ModalOverlay
     onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
  nqe={nqe ? "true" : "false"}
>
  {    loading===0? <ImageAnimation3/>:
      <ModalContent onClick={handleContentClick} heightT={heightT ? 'true' : 'false'} >
          <ScrollBox pad={pad} nqe={nqe?"true":"false"} >
          {pad !== "false"  && <CloseBtn onClick={onClose} />}

            {children}
          </ScrollBox>
      </ModalContent>}
    </ModalOverlay>,
    modalRoot
  );
};

export default Modal;
